/* The Sable & Ochre Museum — shared walkthrough behaviours */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var hasGsap = !!(window.gsap && window.ScrollTrigger);
    var isMobile = window.innerWidth < 768;

    if (hasGsap) gsap.registerPlugin(ScrollTrigger);

    /* ---- Scroll reveals ---- */
    /* :not(.mw-piece) — collection cards get their own cascading stagger in scroll-polish.js */
    var revealEls = document.querySelectorAll('[data-mreveal]:not(.mw-piece)');
    if (reduced) {
      revealEls.forEach(function (el) { el.classList.add('mw-in'); });
    } else if (revealEls.length) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mw-in');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      revealEls.forEach(function (el) { obs.observe(el); });
    }

    /* ---- Entrance: subtle dolly-in on the hero portrait ---- */
    var entranceArt = document.querySelector('.mw-entrance-art .mw-frame');
    if (entranceArt && hasGsap && !reduced) {
      gsap.fromTo(entranceArt,
        { scale: 0.97 },
        {
          scale: 1.03,
          ease: 'none',
          scrollTrigger: {
            trigger: entranceArt,
            start: 'top 90%',
            end: 'bottom 20%',
            scrub: 0.8
          }
        });
    }

    /* ---- Corridor: pinned horizontal walk ---- */
    document.querySelectorAll('.mw-corridor').forEach(function (corridor) {
      var track = corridor.querySelector('.mw-corridor-track');
      if (!track) return;

      if (reduced || isMobile || !hasGsap) {
        corridor.classList.add('mw-static');
        return;
      }

      var artworks = track.querySelectorAll('.mw-artwork');
      var getScroll = function () {
        return Math.max(0, track.scrollWidth - window.innerWidth);
      };
      if (getScroll() <= 0) {
        corridor.classList.add('mw-static');
        return;
      }

      gsap.to(track, {
        x: function () { return -getScroll(); },
        ease: 'none',
        scrollTrigger: {
          trigger: corridor,
          start: 'top top',
          end: function () { return '+=' + getScroll(); },
          pin: true,
          scrub: 0.6,
          invalidateOnRefresh: true,
          snap: artworks.length > 1
            ? { snapTo: 1 / (artworks.length - 1), duration: 0.35, ease: 'power1.inOut' }
            : false
        }
      });
    });

    /* ---- Backdrop parallax: photo drifts clearly as you scroll ---- */
    if (!reduced && hasGsap) {
      document.querySelectorAll('[data-mw-parallax]').forEach(function (bg) {
        var host = bg.closest('section') || bg.parentElement;
        gsap.fromTo(bg,
          { yPercent: -15 },
          {
            yPercent: 15,
            ease: 'none',
            scrollTrigger: {
              trigger: host,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.4
            }
          });
      });
    }

    /* ---- Special exhibition: spotlight switches on ---- */
    document.querySelectorAll('.mw-exhibit').forEach(function (room) {
      if (reduced) { room.classList.add('mw-lit'); return; }
      var lightObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            room.classList.add('mw-lit');
            lightObs.unobserve(room);
          }
        });
      }, { threshold: 0.45 });
      lightObs.observe(room);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

